
<app-header [partner]="true"></app-header>



<section class="home-2-page">
  <div class="home-2-header padd-row">
    <div class="container">
      <div class="home-2-header-main">
        <div class="row">
          <div class="col-md-6">
            <div class="home-2-header-cnt">
              <h2> Become DaktarZ Partner and Help Millions of patients looking for their Healthcare Practitioner </h2>
              <p> Create Your Profile on DaktarZ in Simple Steps </p>
              <p> Registering with your Mobile Number  </p>
              <div class="login-btn mt-4">
                <a [routerLink]="" data-toggle="modal" data-target="#login-page" class="btn-style"> Login </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="home-2-header-img">
              <img src="/assets/images/home-2-new-img-1.png" alt="">
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="home-2-mid padd-row">
    <div class="container">
      <div class="home-2-mid-main">
        <div class="row">
          <div class="col-md-6">
            <div class="home-2-mid-img">
              <img src="/assets/images/home-2-new-middle-img.png" alt="">
            </div>
          </div>
          <div class="col-md-6">
            <div class="home-2-mid-cnt">
              <h2> Benefits of Becoming DaktarZ Partner </h2>
              <ul>
                <li> Manage your profile with the advanced profile editor</li>
                <li> Only Patients who have taken treatment from you can give Feedbacks.</li>
                <li> Provide online consultation to patients via Chat.</li>
                <li> Upload medical records and prescription for patients</li>
                <li> Check patients record from anywhere when they make an appointment&nbsp;</li>
                <li> Registerd pharmacy can check order and deliver medicine.</li>
                <li> Registered Test Labs can provide Health Checkup packages.</li>
                <li> Track the Performance of your Registered Clinic/Pharmacy/Lab</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="home-2-btm padd-row">
    <div class="container">
      <div class="main-heading text-center">
        <h2> Create your free daktarz partner profile in 3 simple steps </h2>
      </div>
      <div class="home-2-btm-main text-center">
        <div class="row">
          <div class="col-md-4">
            <div class="home-2-btm-box">
              <img src="/assets/images/home-2-new-profile-img-1.png" alt="">
              <h4> Register and find yourself on daktarz.com </h4>
              <p> Enter your name, email id, mobile number and clinic or establishment name. </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="home-2-btm-box">
              <img src="/assets/images/home-2-new-profile-img-2.png" alt="">
              <h4> Add your profile information</h4>
              <p> Fill details about you and your practice including your medical registration, fees, timings and more. </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="home-2-btm-box">
              <img src="/assets/images/home-2-new-profile-img-3.png" alt="">
              <h4> Help us verify your details </h4>
              <p> Complete our a simple verification process online, and go live! </p>
            </div>
          </div>
        </div>
        <div class="main-btn mb-4 text-center">
          <a  [routerLink]="" data-toggle="modal" data-target="#login-page" class="btn-style"> Create Your Profile </a>
        </div>
        <p class="mb-0"> <b> Note: </b> Verifying your medical registration and qualification ensures that you get listed as a genuine medical practitioner. </p>
      </div>
    </div>
  </div>
</section>



<router-outlet></router-outlet>


<!--<div class="modal fade" id="login-page">-->
<!--  <div class="modal-dialog modal-dialog-centered">-->
<!--    <div class="modal-content">-->

<!--      &lt;!&ndash; Modal body &ndash;&gt;-->
<!--      <div class="modal-body">-->
<!--        <div class="sign-up-form login-form">-->
<!--          <div id="login-screen" [ngStyle]="{'display': !loginhide ? 'block' : 'none' }">-->
<!--            <h2 class="text-center"><span> Login </span> to Continue </h2>-->
<!--            <form #f="ngForm" (ngSubmit)="EnterOtp(f)">-->
<!--              <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                  <div class="login-mob-img">-->
<!--                    <img src="assets/images/login-mob-img.jpg" alt="image">-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-12">-->
<!--                  <label> Enter Phone Number to Login </label>-->
<!--                  <div class="form-group-main">-->
<!--                    <input type="text"-->
<!--                           ng2TelInput-->
<!--                           (keypress)="numberOnly($event,null)"-->
<!--                           [ng2TelInputOptions]="{initialCountry: 'in'}"-->
<!--                           minlength="10" maxlength="10"-->
<!--                           #phoneNoPartner="ngModel"-->
<!--                           (countryChange)="onCountryChangePartner($event)"-->
<!--                           placeholder="" [(ngModel)]="phoneNo" name="phoneNo" class="form-control"/>-->
<!--                    &lt;!&ndash; <input type="text" required minlength="10" maxlength="10" (keypress)="numberOnly($event,null)"-->
<!--                           #phoneNoPartner="ngModel" class="form-control" [(ngModel)]="phoneNo" name="phoneNo"-->
<!--                           placeholder=""> &ndash;&gt;-->

<!--                    <img src="assets/images/phone.png" alt="image">-->
<!--                    <div *ngIf="phoneNoPartner.invalid && f.submitted" class="alert alert-danger">-->
<!--                      <div *ngIf="f.submitted && phoneNoPartner.errors.required">Number is required</div>-->
<!--                      <div *ngIf="f.submitted && phoneNoPartner.errors.minlength">Phone Number should be of 10 digits-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="col-md-12" style="margin: 11px 0px -24px 0;">-->
<!--                    <label style="display: block;"> Check One Option </label>-->
<!--                    <div class="custom-control custom-checkbox custom-control-inline">-->
<!--                      <input type="checkbox" value="Doctor" (change)="setVal('Doctor');type2='';type3='';type4=''"-->
<!--                             [(ngModel)]="type1"-->
<!--                             class="custom-control-input"-->
<!--                             id="customCheck" name="example1">-->
<!--                      <label class="custom-control-label" for="customCheck"> Doctor </label>-->
<!--                    </div>-->
<!--                    <div class="custom-control custom-checkbox custom-control-inline">-->
<!--                      <input type="checkbox" value="Hospital" (change)="setVal('Hospital');type1='';type3='';type4=''"-->
<!--                             [(ngModel)]="type2"-->
<!--                             class="custom-control-input"-->
<!--                             id="customCheck1" name="example2">-->
<!--                      <label class="custom-control-label" for="customCheck1"> Hospital </label>-->
<!--                    </div>-->
<!--                    <div class="custom-control custom-checkbox custom-control-inline">-->
<!--                      <input type="checkbox" value="Pharmecy" (change)="setVal('Pharmecy');type1='';type2='';type4=''"-->
<!--                             [(ngModel)]="type3"-->
<!--                             class="custom-control-input"-->
<!--                             id="customCheck2" name="example3">-->
<!--                      <label class="custom-control-label" for="customCheck2"> Pharmacy </label>-->
<!--                    </div>-->
<!--                    <div class="custom-control custom-checkbox custom-control-inline">-->
<!--                      <input type="checkbox" value="Labs" (change)="setVal('Labs');type2='';type3='';type1=''"-->
<!--                             [(ngModel)]="type4"-->
<!--                             class="custom-control-input"-->
<!--                             id="customCheck3" name="example4">-->
<!--                      <label class="custom-control-label" for="customCheck3"> Lab </label>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  &lt;!&ndash; <input type="radio" value="Doctor" name="type" [(ngModel)]="type" > Doctor-->
<!--                  <input type="radio" value="Hospital" name="type" [(ngModel)]="type" > Hospital-->
<!--                  <input type="radio" value="Pharmecy" name="type" [(ngModel)]="type" > Pharmacy-->
<!--                  <input type="radio" value="Labs" name="type" [(ngModel)]="type" > Lab &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="col-md-12">-->
<!--                  <input type="submit" value="Send OTP" class="btn-style" id="open-login-otp">-->
<!--                  <div class="error"-->
<!--                       [ngStyle]="{ 'display': errorOtp ? 'block' : 'none', 'color':'red' }">{{ errorOtpMessage }}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </form>-->
<!--          </div>-->
<!--          <div id="login-otp" [ngStyle]="{'display': showotp ? 'block' : 'none' }">-->
<!--            <i class="fa fa-arrow-left" aria-hidden="true" (click)="showotp=false;loginhide=false"></i>-->
<!--            <h2 class="text-center"><span> Verification Code </span></h2>-->
<!--            <form>-->
<!--              <div class="row">-->
<!--                <div class="col-md-12">-->
<!--                  <div class="login-mob-img">-->
<!--                    <img src="assets/images/login-mob-img-otp.jpg" alt="image">-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-12">-->
<!--                  <div class="login-otp-recived">-->
<!--                    <h5> Otp has been sent to <span> {{ phoneNo }} </span></h5>-->
<!--                    <div class="otp-input-group">-->

<!--                      &lt;!&ndash; <input *ngFor="let obj of otpValObjUser" type="text" maxlength="1" (keypress)="numberOnly($event,obj.arg)"  [name]="obj.name" [(ngModel)]="obj.model" [id]="obj.id" class="form-control"> &ndash;&gt;-->
<!--                      <input type="text" id="first" maxlength="1" (keydown)="numberOnlyBack($event,'first','next')"-->
<!--                             (keypress)="numberOnly($event,'next')" name="otp2"-->
<!--                             [(ngModel)]="otpValObj1" class="form-control">-->
<!--                      <input type="text" (keydown)="numberOnlyBack($event,'first','next1')" maxlength="1"-->
<!--                             (keypress)="numberOnly($event,'next1')" id="next" name="otp5"-->
<!--                             [(ngModel)]="otpValObj2" class="form-control">-->
<!--                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'next','next2')"-->
<!--                             (keypress)="numberOnly($event,'next2')" id="next1" name="otp3"-->
<!--                             [(ngModel)]="otpValObj3" class="form-control">-->
<!--                      <input type="text" maxlength="1" (keydown)="numberOnlyBack($event,'next1','next2')"-->
<!--                             (keypress)="numberOnly($event,null)" id="next2" name="otp4"-->
<!--                             [(ngModel)]="otpValObj4" class="form-control">-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-12">-->
<!--                  <input type="submit" value="Login" (click)="checkOtpfunc()" class="btn-style">-->
<!--                  <div *ngIf="verifyOtpError" style="color:red">Otp does not match</div>-->
<!--                  <div class="resend-otp">-->
<!--                    <a [routerLink]="null" (click)="resendOtp()"> Resend OTP </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </form>-->
<!--          </div>-->
<!--          <div id="login-pass" [ngStyle]="{'display': showpass ? 'block' : 'none' }">-->
<!--            <i class="fa fa-arrow-left" (click)="showpass=false;loginhide=false" aria-hidden="true"></i>-->
<!--            <h2 class="text-center"><span> Enter Password </span></h2>-->
<!--            <form>-->
<!--              <div class="row">-->

<!--                <div class="col-md-12">-->
<!--                  <div class="login-otp-recived">-->
<!--                    <input [type]="showEye ? 'password' : 'text'" name="pass"-->
<!--                           [(ngModel)]="Pass" class="form-control">-->
<!--                    <span [class]="showEye ? 'fa fa-fw fa-eye' : 'fa fa-fw fa-eye-slash'"-->
<!--                          (click)="showEye=!showEye"></span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="col-md-12">-->
<!--                  <input type="submit" value="Login" (click)="checkPassfunc()" class="btn-style">-->
<!--                  <div *ngIf="verifyPassError" style="color:red">Password does not match</div>-->
<!--                  <div class="resend-otp">-->
<!--                    <a [routerLink]="null" (click)="forgotPass()"> Forgot Password? </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </form>-->
<!--          </div>-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
